export const eventNameDictEn = (EventName: string) => {
  if (['sb'].includes(EventName)) {
    return <>SB</>;
  }
  if (['pb'].includes(EventName)) {
    return <>PB</>;
  }
  if (['result'].includes(EventName)) {
    return <>Result</>;
  }
  if (['sbTotal'].includes(EventName)) {
    return (
      <>
        Pred. Rank
        <br />
        (SB)
      </>
    );
  }
  if (['pbTotal'].includes(EventName)) {
    return (
      <>
        Pred. Rank
        <br />
        (PB)
      </>
    );
  }
  if (['name'].includes(EventName)) {
    return <>NAME</>;
  }
  if (['total'].includes(EventName)) {
    return <>Total</>;
  }
  if (['i00'].includes(EventName)) {
    return <>100m</>;
  }
  if (['lj'].includes(EventName)) {
    return <>LongJump</>;
  }
  if (['sp'].includes(EventName)) {
    return <>ShotPut</>;
  }
  if (['hj'].includes(EventName)) {
    return <>HighJump</>;
  }
  if (['A00'].includes(EventName)) {
    return <>400m</>;
  }
  if (['ii0h'].includes(EventName)) {
    return <>110mH</>;
  }
  if (['dt'].includes(EventName)) {
    return <>DiscusThrow</>;
  }
  if (['pv'].includes(EventName)) {
    return <>PoleVault</>;
  }
  if (['jt'].includes(EventName)) {
    return <>JavelinThrow</>;
  }
  if (['i500'].includes(EventName)) {
    return <>1500m</>;
  }
  if (['firstDay'].includes(EventName)) {
    return <>Day1</>;
  }
  if (['secondDay'].includes(EventName)) {
    return <>Day2</>;
  }
  if (['i00h'].includes(EventName)) {
    return <>100mH</>;
  }
  if (['z00'].includes(EventName)) {
    return <>200m</>;
  }
  if (['B00'].includes(EventName)) {
    return <>800m</>;
  }

  return <>{EventName}</>;
};

export const eventNameDictt = {
  // sb100: "100m",
  // sblj: "走幅跳",
  // sbsp: "砲丸投",
  // sbhl: "走高跳",
  // sb400: "400m",
  // sb110h: "110mH",
  // sbdt: "円盤投",
  // sbpv: "棒高跳",
  // sbjt: "やり投",
  // sb1500: "1500m",
  // i00h: "100mH",
  // hj: "走高跳",
  // sp: "砲丸投",
  // z00: "200m",
  // lj: "走幅跳",
  // jt: "やり投",
  // B00: "800m",
  // i00: "100m",
  // dt: "円盤投",
  // day1: "1日目",
  // day2: "2日目",
  // bo: "60m",
  // b0h: "60mH",
  // iooo: "1000m",
};
